import classes from "./index.module.scss";

export default function Card({ year, text }) {
  return (
    <div data-year={year} className={classes.card} dangerouslySetInnerHTML={{__html: text}}/>
  );
}
